import { Box } from "@chakra-ui/react";
import React from "react";

/***
 * Fix for bottom padding of last element in a scrollable container.
 *
 * See: https://stackoverflow.com/q/61227008
 */
export const ScrollBottomPaddingHack: React.FC = () => (
  <Box height="1px" flexShrink={0} />
);
